import UploadASpreadsheet from './UploadASpreadsheet';
import { Stack, Step, StepLabel, Stepper } from '@mui/material';
import BulkProductsTable from './BulkProductsTable';
import MatchHeaders from './MatchHeaders';
import { FormikProps } from 'formik';
import { AddFromSpreadsheetFormValues } from './AddProductsFromSpreadsheet';
import AddProductsCompleted from '../AddProductsCompleted';

const SpreadsheetSteps = (props: FormikProps<AddFromSpreadsheetFormValues>) => {
  const renderStep = (step: number) => {
    switch (step) {
      case 0:
        return <UploadASpreadsheet {...props} />;
      case 1:
        return <MatchHeaders {...props} />;
      case 2:
        return <BulkProductsTable {...props} />;
      case 3:
        return <AddProductsCompleted {...props} />;
    }
  };

  return (
    <Stack>
      <Stepper activeStep={props.values.activeStep} sx={{ mb: 4 }}>
        <Step>
          <StepLabel>Upload your spreadsheet</StepLabel>
        </Step>
        <Step>
          <StepLabel>Match Columns</StepLabel>
        </Step>
        <Step>
          <StepLabel>Verify</StepLabel>
        </Step>
        <Step>
          <StepLabel>Complete</StepLabel>
        </Step>
      </Stepper>
      {renderStep(props.values.activeStep)}
    </Stack>
  );
};

export default SpreadsheetSteps;
